import { createGlobalStyle } from "styled-components";
import "@fontsource/inter";

const Styles = createGlobalStyle`
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    user-select: none;
  }

  body {
    font-family: 'Inter', sans-serif;
  }
`;

export default Styles;
